package io.jsonize.web.services

fun logButtonClick(label: String) {
    val safe = label.trim().ifEmpty { "button" }
    logAnalyticsEvent("button_click", mapOf("label" to safe))
}

expect fun logAnalyticsEvent(name: String, params: Map<String, String> = emptyMap())
